require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/var/www/html/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/var/www/html/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/var/www/html/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/var/www/html/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/var/www/html/node_modules/babel-preset-stage-0/lib/index.js\",\"/var/www/html/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./about.en.js") })
        }
      }, "component---src-pages-about-en-js");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=component---src-pages-about-en-js!./src/pages/about.en.js
// module id = 705
// module chunks = 231608221292675